import { useEffect, useRef, useState } from 'react';
import { Mode } from '.';

export const useFade = (mode: Mode, imageCount: number, delay: number) => {
  const [index, setIndex] = useState(0);
  const interval = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (mode === 'fade') {
      interval.current = setInterval(() => {
        setIndex((prev) => {
          const next = prev + 1;
          return next >= imageCount ? 0 : next;
        });
      }, delay || 1500);
    }

    return () => {
      clearInterval(interval.current);
    };
  }, []);

  return index;
};
